import { render, staticRenderFns } from "./ratePeriod.vue?vue&type=template&id=3952c01c&"
import script from "./ratePeriod.vue?vue&type=script&lang=js&"
export * from "./ratePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3952c01c')) {
      api.createRecord('3952c01c', component.options)
    } else {
      api.reload('3952c01c', component.options)
    }
    module.hot.accept("./ratePeriod.vue?vue&type=template&id=3952c01c&", function () {
      api.rerender('3952c01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/ratePeriod.vue"
export default component.exports